import axios from "./axios";

const authCheckLogin = (payload) => {
  return axios.post("authenticate/login", payload);
};

const authCheckLogout = () => {
  return axios.get("authenticate/logout");
};

const authForgotPassword = (payload) => {
  return axios.post("authenticate/forgot_password", payload);
};

const authResetPassword = (payload) => {
  return axios.post("authenticate/reset_password", payload);
};

const trxDeposit = (payload) => {
  return axios.post("transaction/deposit", payload);
};

const trxWithdrawal = (payload) => {
  return axios.post("transaction/withdrawal", payload);
};
const trxCanceled = (payload) => {
  return axios.post("transaction/canceled", payload);
};
const trxRejected = (payload) => {
  return axios.post("transaction/rejected", payload);
};

const trxRiwayat = (payload) => {
  return axios.post("information/history", payload);
};
const trxRiwayatAdmin = (payload) => {
  return axios.post("information/history_admin", payload);
};
const trxApprovedDeposit = (payload) => {
  return axios.post("transaction/approved_deposit", payload);
};
const trxWithdrawalApplication = (payload) => {
  return axios.post("transaction/withdrawal_application", payload);
};
const trxApprovedWithdrawal = (payload) => {
  return axios.post("transaction/approved_withdrawal", payload);
};
const trxHandoverDeposit = (payload) => {
  return axios.post("transaction/handover_deposit", payload);
};
const trxHandoverWithdrawal = (payload) => {
  return axios.post("transaction/handover_withdrawal", payload);
};
const trxFinalWithdrawalStudent = (payload) => {
  return axios.post("transaction/final_withdrawal_student", payload);
};
const trxAppvrovedAuthorizationDeposit = (payload) => {
  return axios.post("transaction/approved_authorization_deposit", payload);
};
const trxAppvrovedAuthorizationWithdrawal = (payload) => {
  return axios.post("transaction/approved_authorization_withdrawal", payload);
};

const detailRiwayat = (payload) => {
  return axios.post("information/detail", payload);
};
const infoProfile = (payload) => {
  return axios.post("profile/show", payload);
};
const getMaster = (payload) => {
  return axios.post("information/master", payload);
};
const infoWaitingOfficer = (payload) => {
  return axios.post("information/waiting_officer", payload);
};
const infoReadyWithdrawal = (payload) => {
  return axios.post("information/ready_withdrawal", payload);
};
const infoWaitingDelivery = (payload) => {
  return axios.post("information/waiting_delivery", payload);
};
const infoHistoryOfficer = (payload) => {
  return axios.post("information/history_officer", payload);
};
const infoSuccess = (payload) => {
  return axios.post("information/success", payload);
};
const infoVerification = (payload) => {
  return axios.post("information/verification", payload);
};
const infoFinishDelivery = (payload) => {
  return axios.post("information/finish_delivery", payload);
};
const infoFinishReceive = (payload) => {
  return axios.post("information/finish_receive", payload);
};
const infoDepositOfficer = (payload) => {
  return axios.post("information/list_deposit_officer", payload);
};
const infoMutasiSaldo = (payload) => {
  return axios.post("information/total_mutasi_saldo", payload);
};
const infoListWithdrawalOfficer = (payload) => {
  return axios.post("information/list_withdrawal_officer", payload);
};
const infoSchool = (payload) => {
  return axios.post("information/school", payload);
};
const infoTeacher = (payload) => {
  return axios.post("information/teacher", payload);
};
const infoHistoryProfitSharing = (payload) => {
  return axios.post("information/history_profit_sharing", payload);
};
const infoTakeDepositWithdrawal = (payload) => {
  return axios.post("information/take_deposit_withdrawal", payload);
};
const infoAuthorizationTransaction = (payload) => {
  return axios.post("information/authorization_transaction", payload);
};
const updateProfileStudent = (payload) => {
  return axios.post("profile/edit_student", payload);
};
const updateProfileTeacher = (payload) => {
  return axios.post("profile/edit_teacher", payload);
};
const updateProfileAdmin = (payload) => {
  return axios.post("profile/edit_admin", payload);
};
const updateCredentials = (payload) => {
  return axios.post("profile/update_credentials", payload);
};
const getSetorQr = (username) => {
  return axios.get(
    `information/take_deposit/${username}`
  );
};
const getTarikQr = (username) => {
  return axios.get(
    `information/take_withdrawal/${username}`
  );
};
const getSaldoPerKelas = (payload) => {
  return axios.post("information/saldo_per_kelas", payload);
};

const duelHost = (payload) => {
  return axios.post("duel/host", payload);
};
const duelJoin = (payload) => {
  return axios.post("duel/join", payload);
};
const duelAnswer = (payload) => {
  return axios.post("duel/answer", payload);
};
const duelLeave = (payload) => {
  return axios.post("duel/leave", payload);
};
const duelRematch = (payload) => {
  return axios.post("duel/rematch", payload);
};
const duelTimeout = (payload) => {
  return axios.post("duel/timeout", payload);
};
export default {
  authCheckLogin,
  authCheckLogout,
  authForgotPassword,
  authResetPassword,
  trxDeposit,
  trxWithdrawal,
  trxRiwayatAdmin,
  trxRiwayat,
  trxRejected,
  trxCanceled,
  detailRiwayat,
  infoProfile,
  infoWaitingOfficer,
  infoReadyWithdrawal,
  infoWaitingDelivery,
  getSaldoPerKelas,
  infoSuccess,
  infoSchool,
  infoTakeDepositWithdrawal,
  infoTeacher,
  infoFinishDelivery,
  infoFinishReceive,
  infoVerification,
  infoMutasiSaldo,
  infoDepositOfficer,
  infoListWithdrawalOfficer,
  infoHistoryOfficer,
  infoHistoryProfitSharing,
  infoAuthorizationTransaction,
  getMaster,
  getSetorQr,
  getTarikQr,
  trxWithdrawalApplication,
  trxApprovedDeposit,
  trxApprovedWithdrawal,
  trxHandoverDeposit,
  trxHandoverWithdrawal,
  trxAppvrovedAuthorizationDeposit,
  trxAppvrovedAuthorizationWithdrawal,
  updateProfileStudent,
  updateProfileTeacher,
  updateProfileAdmin,
  updateCredentials,
  trxFinalWithdrawalStudent,
  duelHost,
  duelJoin,
  duelAnswer,
  duelTimeout,
  duelLeave,
  duelRematch,
};
